import { Component, OnInit, ViewChild } from '@angular/core';

import { BehaviorSubject, filter, Observable } from "rxjs";

import { UserTableService } from 'src/service/user.service';

import { CustomerService, UserService } from 'src/api/services';
import { User,Customer, CustomerSummary } from 'src/api/models';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { ToastrService } from 'ngx-toastr';

// todo: fix styles
// todo: install license

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {


  public userFilter: string;
  public newuser : User = {} as User;
  public user : User = {} as User;
  public customers : CustomerSummary[];

  public remoteData: Observable<any[]>;

  constructor(
    public userTableService: UserTableService,
    public userService: UserService,
    private customerService: CustomerService,
    private toaster: ToastrService,
    public app: ApplicationConfigService
    ) { 
    this.remoteData = this.userTableService.remoteData;
    this.customerService.CustomerGetAllCustomers().subscribe(c => this.customers = c);
  }

  ngOnInit(): void {    
    this.userTableService.get();
  }

  public getCustomerName(customerId: number) {
    if (!this.customers) return "";
    for (var c of this.customers){
      if (c.customerId == customerId){
        return c.customerName;
      }
    }
    return customerId;
  }

  public removeUser(user: User) {
    this.userTableService.remove(user);
  }

  public updateUser() {
    //this.user.mappedCustomers = (this.user.mappedCustomers as any[]).map(c => typeof c === 'object' ? c.customerId : c);
    this.userTableService.update(this.user);
  }

  public addUser() {
    this.userTableService.add(this.newuser);
  }

  public canAddUser() : boolean {
    if (!this.newuser) return false;
    if (!this.newuser.email) return false;
    if (!this.newuser.displayName) return false;
    if (!this.newuser.customerId) return false;
    return true;
  }

  isValidEmail(email: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  public customer : Customer;
  
  public filterCustomer(filter: string, customer: Customer){
    this.customer = customer;
    this.userTableService.filter(this.userFilter, customer);
    //this.treeGrid.filter("category", category, IgxStringFilteringOperand.instance().condition('contains'));
  }
  
  public clearFilterCustomer(){
    this.customer = null;
    this.userTableService.filter(this.userFilter, null);
    //this.service.filter
    //this.treeGrid.clearFilter("category");
  }

  public clearCache(user: User){
    this.userService.UserResetUserCache({customerId:user.customerId, userId:user.userId}).subscribe(r => {
      this.toaster.success("For " + user.displayName, "Cache Cleared");
    });
  }


  /*public onRemoveMappedCustomer(user: User, event: any){
    const index = user.mappedCustomers.indexOf(event.customerId);  
    if (index >= 0) {
      user.mappedCustomers.splice(index, 1);
    } 
    //this.updateUser();
  }

  public onAddMappedCustomer(user: User, event: any){
    if (!user.mappedCustomers) user.mappedCustomers = [];
    user.mappedCustomers.push(event.customerId);
    //this.updateUser();
  }*/
}
